module.exports = __webpack_public_path__ + "static/estrategia11-322e06b0fa358e262d7680bf7f3343a7.jpg";